import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Button } from '../ui/button';
import { X } from 'lucide-react';

const CookieBanner = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 bg-[#1a1a1a] border-t border-gray-800 z-[9999] p-4 shadow-lg"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-roboto text-gray-300 text-sm text-center sm:text-left">
          {t('cookie.message')}
        </p>
        <div className="flex items-center gap-3">
          <Button
            data-testid="cookie-decline-btn"
            onClick={handleDecline}
            variant="outline"
            className="border-gray-600 text-gray-300 hover:bg-gray-800 font-roboto text-sm px-4 py-2"
          >
            {t('cookie.decline')}
          </Button>
          <Button
            data-testid="cookie-accept-btn"
            onClick={handleAccept}
            className="bg-[#e21b1b] hover:bg-[#c41818] text-white font-roboto text-sm px-4 py-2"
          >
            {t('cookie.accept')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
